export default "__VITE_ASSET__FTGhLo1h__"